import React from 'react';
import PropTypes from 'prop-types';

import { cartItemsArrayPropTypes } from 'helpers/propTypes';

import Breadcrumb from 'components/commons/Breadcrumb';
import Loading from 'components/commons/Loading';
import Benefit from 'components/commons/Benefit';
import CheckoutMobileSummaryBar from '../CheckoutMobileSummaryBar';

import './CheckoutTextil.scss';
import CartSummaryTextil from 'components/commons/CartSummary/CartSummaryTextil';

const CheckoutTextil = (props) => {
  const {
    cartSize, items, loading, minimumPurchase, renderForm, shippingText, subtotal,
    url, urlText, coupon, subTotEnv, cuotasMP, onOpenPaymentModal, showMPButton,
    paymentMethods
  } = props;

  const showCart = cartSize > 0;

  return (
    <div data-testid="checkout-textil-page">
      <div className="container">
        <div className="row">
          <div className="col clearfix">
            <Breadcrumb urls={['/carrito', url]} names={['Carrito', urlText]} />
            <div className="row">
              {loading && <Loading size={80} />}
              {!loading && (
                showCart ? (
                  <>
                    <div className="col-md-7">
                      {renderForm()}
                    </div>
                    <div className="col-md-5 checkout-cart-summary d-none d-md-block">
                      <CartSummaryTextil
                        items={items}
                        shippingText={shippingText}
                        coupon={coupon}
                        subtotal={subtotal}
                        subTotEnv={subTotEnv}
                        cuotasMP={cuotasMP}
                        onOpenPaymentModal={onOpenPaymentModal}
                        showMPButton={showMPButton}
                        paymentMethods={paymentMethods}
                      />
                    </div>
                    <CheckoutMobileSummaryBar
                      subtotal={subtotal}
                      shippingText={shippingText}
                      coupon={coupon}
                      subTotEnv={subTotEnv}
                      paymentMethods={paymentMethods}
                    >
                      <CartSummaryTextil
                        items={items}
                        shippingText={shippingText}
                        coupon={coupon}
                        subtotal={subtotal}
                        subTotEnv={subTotEnv}
                        cuotasMP={cuotasMP}
                        onOpenPaymentModal={onOpenPaymentModal}
                        showMPButton={showMPButton}
                        paymentMethods={paymentMethods}
                      />
                    </CheckoutMobileSummaryBar>
                    <div className="col">
                      <h4 className="text-center minimum-purchase" data-testid="minimum-purchase">
                        {`* Compra mínima: $${minimumPurchase}`}
                      </h4>
                    </div>
                  </>
                ) : (
                  <div className="col">
                    <h2 className="text-center" data-testid="empty-cart">
                      El carrito está vacío
                    </h2>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <Benefit minimumPurchase={minimumPurchase} />
      </div>
    </div>
  );
};

CheckoutTextil.defaultProps = {
  coupon: null,
};

CheckoutTextil.propTypes = {
  cartSize: PropTypes.number.isRequired,
  coupon: PropTypes.shape({
    id: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired,
  }),
  items: cartItemsArrayPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  minimumPurchase: PropTypes.number.isRequired,
  renderForm: PropTypes.func.isRequired,
  shippingText: PropTypes.string.isRequired,
  subtotal: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  urlText: PropTypes.string.isRequired,
};

export default CheckoutTextil;
